<div class="flightmap-container">
	<div id="flightmap" [ngClass]="'speed-' + viewer?.speed"></div>
	@if (loading || error) {
		<div class="flightmap-overlay">
			@if (loading) {
				<div>
					<div class="logo-spin"></div>
					Loading flight map...
				</div>
			}
			@if (error) {
				<div>
					<div class="logo-spin stopped"></div>
					{{error}}
				</div>
			}
		</div>
	}
</div>
<app-dvs-chart [hidden]="error" #scrubberChart [options]="scrubberOptions" [height]="'150px'" [timezone]="fleet ? fleet.time_offset_hours : 0" [short]="true"></app-dvs-chart>

@if (!loading && !error) {
	<div>
		<div class="row">
			@if (pathFrame && pathFrame.ts) {
				<div class="col-lg-6">
					<div class="flat-indicator">
						<span class="label">Timestamp:</span> {{ (pathFrame.ts * 1000) | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0) }}
					</div>
				</div>
			}
			@if (pathFrame && pathFrame.regime_id) {
				<div class="col-lg-6">
					<div class="flat-indicator">
						<span class="label">Regime:</span> {{ lookupRegime(pathFrame.regime_id) }}
					</div>
				</div>
			}
		</div>
		<div class="row">
			@for (param of stateParams; track param) {
				@if (param.selected) {
					<app-indicator-number [frame]="pathFrame" [field]="param.name.toLowerCase()" [label]="param.name" [units]="param.units"></app-indicator-number>
				}
			}
		</div>
		<div class="text-center">
			<button (click)="ChooseIndicators()" class="button wide">Choose indicators</button>
		</div>
	</div>
}

<ng-template #indicatorModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Choose indicators</h4>
		<button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body">
		<div class="container">
			<div class="row">
				@for (prop of selectorParams; track prop) {
					<div class="col-sm-6 col-lg-4">
						<label>
							<input type="checkbox" [(ngModel)]="prop.selected"> {{prop.name}}
						</label>
					</div>
				}
			</div>
		</div>
		<button (click)="ApplyIndicators()" class="button green block mt-3">Apply selections</button>
	</div>
</ng-template>